import React, {Component} from 'react';
import './InterventionType.css';
import PropTypes from 'prop-types';
import Badge from "../common/badge/Badge";
import fleetbackIcon from "../../img/fleetback-icon.svg";


class InterventionType extends Component {

  render() {
    const {properties} = this.props.journey;

    if (!properties) {
      return null;
    }

    const {reception = {}, services={}} = properties;

    const badges = [];
    if (reception.dropOff && reception.dropOff.fastLane === true) {
      badges.push("FL");
    }
    if (reception.dropOff && reception.dropOff.duringWorkingHours === false) {
      badges.push("\u2192 24/7");
    }
    if (reception.pickUp && reception.pickUp.duringWorkingHours === false) {
      badges.push("24/7 \u2192")
    }

    if (services.valueServicesCart) {
      badges.push("VS")
    }

    if (this.props.fleetback){
      badges.push(<img style={{height:'1.2rem'}} src={fleetbackIcon}/>)
    }

    if (!badges || badges.length === 0){
      return null;
    }

    return (
      <React.Fragment>
        {badges.map((badge, index) => {
          return <Badge key={index}>{badge}</Badge>
        })}
      </React.Fragment>

    );
  }
}

export default InterventionType;

InterventionType.propTypes ={
  fleetback: PropTypes.bool,
  journey: PropTypes.shape({
    properties: PropTypes.object,
  }),
}



// WEBPACK FOOTER //
// ./src/components/intervention/InterventionType.js